import type { FaireProductEntity } from "../../entity_types/product";

export const p_8fnkbdmbh9: FaireProductEntity = {
  token: "p_8fnkbdmbh9",
  type: "product",
  name: "Horse Cotton Tea Towel",
  brandToken: "b_zqgv7epztb",
  brandName: "Nice life",
  imageUrl:
    "https://cdn.faire.com/fastly/ef775fad856472e948dbc78f19773a5bda251f55330fc2eca548528dce416677.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/177f2621b1363878f489527e2279a261290426ed820e34b5f3d3bcc5582633e3.png",
    "https://cdn.faire.com/fastly/d100cb8f21e3ba31e6a523297c1ac27ce21650c8eb726e7bb0f6a8281ffc0dd6.png",
    "https://cdn.faire.com/fastly/3083903255b85833c9bbef4fbe1e8c526befccfbbf5e90ae650d32fb49d046a8.png",
    "https://cdn.faire.com/fastly/2e5a3676d1db28b350d35d2ac905c6033f1ae8c90121b96c996f8cf7e4edd65b.png",
  ],
  priceDollars: 10,
  description:
    "Welcome to the whimsical world of Nice Life. Our Horse Tea Towel is an essential addition to your kitchen. Crafted in our Detroit-based artist studio, each piece is screen printed and hand-cured, embodying our commitment to small batch production. Our meticulous process ensures every towel meets our standards. Embrace our sustainable and eco-friendly approach to home living. Brighten your kitchen experience with our unique, playful design.\n\n100% natural cotton flour sack tea towel\n\n19” by 19”\n\nScreenprinted with water based ink\n\nEach towel is individually screen printed and cured in my studio by hand - therefore please allow slight variance in detail as this is meant to enhance the beauty of a hand printed item by the artist.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:54.636Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
